<template>
  <form class="form">
    <FormSelect :label="$t('form.label.category.base')" name="parent_id" :options="categoryOptions"
                v-model="form.fields.parent_id" :message="$t('form.messages.category.choose')" required/>
    <FormInput :label="$t('form.label.sub_category.title')" v-model="form.fields.title" name="title" required/>
    <FormFile :label="`${$t('form.label.icon')}`" v-model="form.fields.icon" name="icon" accept=".png,.svg"
              :maxSize="500" :message="$t('form.messages.500_ko_png_svg')" required preview/>
  </form>
</template>

<script>
import {FormFile, FormInput, FormSelect} from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
  name: 'AddEditSubCategory',
  mixins: [FormValidMixin],
  components: {
    FormFile,
    FormInput,
    FormSelect
  },
  data() {
    return {
      form: {
        fields: {
          parent_id: {
            value: null,
            valid: false
          },
          title: {
            value: null,
            valid: false
          },
          icon: {
            file: '',
            previewName: null,
            previewUrl: null,
            value: '',
            valid: false
          },
        },
        submitted: false
      }
    }
  },
  computed: {
    categoryOptions() {
      return Array.from(this.$category.all)
          .map(category => ({
            key: category.id,
            value: category.title
          }))
          .sort((a, b) => a.key - b.key)
    }
  },
  methods: {
    messageToTooltip() {
      let title = this.form.fields.title.value

      if (this.$route.query.action === this.$query.ACTION.EDIT) {
        this.$popup.report(`${title} ${this.$t('popup.modifiedElement')}`, false)
      } else {
        this.$popup.report(`${title} ${this.$t('popup.createdElement')}`, false)
      }
    },
    async submit() {
      if (this.form.valid) {
        this.form.submitted = true

        const formData = {
          parent_id: this.form.fields.parent_id.value,
          title: this.form.fields.title.value,
        }

        let currentId
        this.$route.query.action === this.$query.ACTION.EDIT
            ? currentId = await this.$category.update(this.$route.query.id, formData)
            : currentId = await this.$category.store(formData)

        if (this.form.fields.icon.file) {
          await this.$category.uploadIcon(currentId, this.form.fields.icon.file[0])
        }

        this.form.submitted = false

        this.messageToTooltip()
      }
    }
  },
  mounted() {
    if (this.$route.params.categoryId) {
      this.form.fields.parent_id = {valid: true, value: this.$route.params.categoryId}    
    }

    if (this.$route.query.action === this.$query.ACTION.EDIT && this.$category.sub_categories) {
      const subCategory = Array.from(this.$category.sub_categories).find(({id}) => id.toString() === this.$route.query.id)

      if (subCategory) {
        this.form.fields.parent_id = {valid: true, value: subCategory.parent_id}
        this.form.fields.title = {valid: true, value: subCategory.title}

        if (subCategory.icon) {
          this.form.fields.icon.previewName = subCategory.icon.name
          this.form.fields.icon.previewUrl = subCategory.icon.url
        }
      }
    }
  }
}
</script>